import { StudyFidFormatter } from '@/entities/study';

/**
 * Renders the sequential row number of the support request study table. Returns the zero-based row index incremented by one.
 *
 * @param cell - Raw value of the column for this row.
 * @param row - Study record backing the row.
 * @param index - Zero-based index of the row.
 * @returns The one-based row number.
 */
const formatterDummyField = (cell: any, row: any, index: any) => index + 1;

/**
 * Renders the study ID cell of the support request study table as a clickable link. Passes the cell value to StudyFidFormatter with a click handler that opens the study info drawer for the row through toggleDisplayDrawer.
 *
 * @param cell - Raw value of the column for this row.
 * @param row - Study record backing the row.
 * @param rowIndex - Zero-based index of the row.
 * @param toggleDisplayDrawer - Callback opening the study info drawer for a row.
 * @returns The study id link element.
 */
const studyFidFormatter = (cell: any, row: any, rowIndex: any, toggleDisplayDrawer: any) => (
  <StudyFidFormatter
    studyId={cell}
    handleClickStudyId={() => {
      toggleDisplayDrawer(row);
    }}
  />
);

export { formatterDummyField, studyFidFormatter };
